import React from "react";
import { Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";

interface DeleteModalProps {
    show?: boolean;
    onDeleteClick?: () => void;
    onCloseClick?: () => void;
    recordId?: string;
    loading?: boolean;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
                                                     show,
                                                     onDeleteClick,
                                                     onCloseClick,
                                                     loading,
                                                 }) => {
    return (
        <Modal
            fade
            isOpen={show}
            centered
            backdrop="static"
            className="border-0"
            modalClassName="modal-dialog-centered"
            contentClassName="border-0 rounded-4 shadow overflow-hidden"
        >
            {/* HEADER */}
            <ModalHeader
                className="p-3"
                style={{ backgroundColor: '#d19221' }}
            >
                <h5 className="modal-title mb-0 text-white">
                    Confirmar desactivación
                </h5>

                <button
                    type="button"
                    onClick={onCloseClick}
                    className="btn p-0 border-0 position-absolute top-0 end-0 m-3"
                    style={{ background: 'transparent' }}
                >
                    <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    >
                        <path d="M18 6L6 18M6 6l12 12" />
                    </svg>
                </button>
            </ModalHeader>

            {/* BODY */}
            <ModalBody className="px-4 py-4 text-center">
                <div
                    className="mx-auto mb-4 d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                        width: '72px',
                        height: '72px',
                        backgroundColor: '#fff3e0'
                    }}
                >
                    <i className="ri-delete-bin-line fs-1 text-danger"></i>
                </div>

                <h5 className="fw-semibold mb-2">
                    ¿Desactivar registro?
                </h5>

                <p className="text-muted mb-0">
                    Esta acción desactivará el registro seleccionado. ¿Está seguro de que desea continuar?
                </p>
            </ModalBody>

            {/* FOOTER */}
            <ModalFooter className="px-4 py-3 border-top">
                <div className="w-100 d-flex justify-content-end gap-2">
                    <button
                        type="button"
                        className="btn btn-light"
                        onClick={onCloseClick}
                    >
                        Cancelar
                    </button>

                    <button
                        type="button"
                        className="btn btn-primary"
                        id="deactivate-record"
                        onClick={onDeleteClick}
                        disabled={loading}
                    >
                        {loading ? (
                             <>
                                 <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                 Desactivando...
                             </>
                         ) : (
                             'Sí, desactivar'
                         )}
                    </button>
                </div>
            </ModalFooter>
        </Modal>
    ) as unknown as JSX.Element;
};

export default DeleteModal;
